import React, { useState, useEffect } from 'react';
import { Space, Breadcrumb, Row, Col, Spin } from 'antd';
import { 
  CardLayout, 
  Calender, 
  OperatorEditModal, 
  B2cOperatorEditModal,
  ProjectScheduleEditModal, 
  B2cScheduleEditModal,
  B2cEditModal,
  ProjectEditModal
 } from 'components/molecules';
import SearchBox from './SearchBox'
import moment, { Moment } from 'moment'
import { useOperate } from 'hooks';
import { useLocation, useNavigate } from 'react-router';
import qs from 'query-string';
import { addNewSearch } from 'utils/utils';
import { usePopupManager } from 'react-popup-manager';
import * as XLSX from 'xlsx';

export interface OperateProps {}

const Operate = ({}: OperateProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const [searchDate, setSearchDate] = useState<string>(moment().format('YYYY-MM-DD')); 
  const [scheduleData, setScheduleData] = useState<ScheduleListDto[]>([]);
  const [isLoding, setIsLoading] = useState<boolean>(false);   

  /* ======================================================
   * hooks
   * ====================================================== */
  const { scheduleList, refetch } = useOperate()
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = qs.parse(location.search);
  const { open } = usePopupManager();

  /* ======================================================
   * events
   * ====================================================== */ 

  const onClickSchedule = (item: DailyScheduleDto) => {
    if (item.project_type === 'b2b') {
      open(ProjectScheduleEditModal, {
        group_id: item.parent_id,
        id: item.id,
        onClose: (isOk) => {refetch();},
      }); 
    }else if (item.project_type === 'b2c') {
      open(B2cScheduleEditModal, {
        group_id: item.group_id,
        id: item.id,
        onClose: (isOk) => {
          if (isOk) {
            refetch();
          }
        },
      }); 
    }
  };

  const onClickProject = (item: DailyScheduleDto) => {
    if (item.project_type === 'b2b') {
      open(ProjectEditModal, {
        id: item.parent_id,
        pType: 'confirm',
        onClose: (isOk) => {refetch();},
      }); 
    }else if (item.project_type === 'b2c') {
      open(B2cEditModal, {
        id: item.group_id,
        onClose: (isOk) => {
          if (isOk) {
            refetch();
          }
        },
      }); 
    }
  };  

  const prevMonth = () => {
    const date = moment(searchDate).add(-1, 'month').format('YYYY-MM-DD');
    setSearchDate(date);
    setScheduleData([]); 
    navigate({
      ...location,
      search: addNewSearch(location.search, { searchDateStart: date }),
    });    
  };
  const nextMonth = () => {
    const date = moment(searchDate).add(1, 'month').format('YYYY-MM-DD');
    setSearchDate(date);
    setScheduleData([]); 
    navigate({
      ...location,
      search: addNewSearch(location.search, { searchDateStart: date }),
    }); 
  };

  const makePopupContent = (item: DailyScheduleDto) => {
    if (item.id > 0) {
      const lecturers = (!!item.lecturer_name)?item.lecturer_name.split(','):[];
      
      if (item.project_type === 'b2b') {
        return (
          <div className='schedule_popup' style={{width:'300px', fontSize:'12px'}}>
          <Row>
            <Col flex={'80px'}>◦기업명</Col>
            <Col flex={'220px'}>{item.company_name}</Col>
          </Row> 
          <Row>
            <Col flex={'80px'}>◦프로젝트명</Col>
            <Col flex={'220px'}><a onClick={()=>onClickProject(item)}>{item.project_title}</a></Col>
          </Row>    
          <Row>
            <Col flex={'80px'}>◦강사명</Col>
            <Col flex={'220px'}>{
              lecturers.map((lt) => {
                const info = lt.split('_');
                return (
                  <a key={info[0]} onClick={()=>onClickSchedule({...item, id: Number(info[0]), group_id:item.group_id})}>{info[1]}&nbsp;</a>
               )})
            }</Col>
          </Row>         
          <Row>
            <Col flex={'80px'}>◦시간</Col>
            <Col flex={'220px'}>{item.start_time}~{item.end_time}</Col>
          </Row> 
          <Row>
            <Col flex={'80px'}>◦운영자</Col>
            <Col flex={'220px'}>{item.operator}</Col>
          </Row>         
          <Row>
            <Col flex={'80px'}>◦강의장소</Col>
            <Col flex={'220px'}>{item.lecture_place}</Col>
          </Row>  
          <Row>
            <Col flex={'80px'}>◦강의요청서</Col>
            <Col flex={'220px'}><a href={item.notion_url} target='_blank' rel="noreferrer">{item.notion_url}</a></Col>
          </Row>   
          <Row>
            <Col flex={'80px'}>◦PM</Col>
            <Col flex={'220px'}>{item.pm}</Col>
          </Row>     
          <Row>
            <Col flex={'80px'}>◦CM</Col>
            <Col flex={'220px'}>{item.cm}</Col>
          </Row>                                                                                                                                                                                                                                                                                             
        </div>
        )
      } else if (item.project_type === 'b2c') {
        return (
          <div className='schedule_popup' style={{width:'300px', fontSize:'12px'}}>
          <Row>
            <Col flex={'80px'}>◦과정명</Col>
            <Col flex={'220px'}>{item.project_title}</Col>
          </Row>    
          <Row>
            <Col flex={'80px'}>◦강사명</Col>
            <Col flex={'220px'}>{
              lecturers.map((lt) => {
                const info = lt.split('_');
                return (
                  <a key={info[0]} onClick={()=>onClickSchedule({...item, id: Number(info[0]), group_id:item.group_id})}>{info[1]}&nbsp;</a>
               )})
            }</Col>                        
          </Row>         
          <Row>
            <Col flex={'80px'}>◦시간</Col>
            <Col flex={'220px'}>{item.start_time}~{item.end_time}</Col>
          </Row> 
          <Row>
            <Col flex={'80px'}>◦운영자</Col>
            <Col flex={'220px'}>{item.operator}</Col>
          </Row>         
          <Row>
            <Col flex={'80px'}>◦강의장소</Col>
            <Col flex={'220px'}>{item.lecture_place}</Col>
          </Row>  
          <Row>
            <Col flex={'80px'}>◦강의요청서</Col>
            <Col flex={'220px'}><a href={item.notion_url} target='_blank' rel="noreferrer">{item.notion_url}</a></Col>
          </Row>   
          <Row>
            <Col flex={'80px'}>◦PM</Col>
            <Col flex={'220px'}>{item.pm}</Col>
          </Row>     
          <Row>
            <Col flex={'80px'}>◦CM</Col>
            <Col flex={'220px'}>{item.cm}</Col>
          </Row>                                                                                                                                                                                                                                                                                             
        </div>
        )
      }
    }
  }

  const onClickInfo = (item: DailyScheduleDto) => {
    if (item.project_type === 'b2b') {
      open(OperatorEditModal, {
        group_srl: item.parent_id,
        schedule_date: item.start_date,
        onClose: (isOk, op) => {
          if (isOk) {
            refetch();
          }
        },
      }); 
    } else if (item.project_type === 'b2c') {
      open(B2cOperatorEditModal, {
        group_srl: item.parent_id,
        schedule_date: item.start_date,
        onClose: (isOk, op) => {
          if (isOk) {
            refetch();
          }
        },
      }); 
    }
  };

  const onExcelDownload = () => {
    setIsLoading(true); 

    const schedules: DailyScheduleDto[] = [];
    scheduleData.forEach(item => {
      item.schedules.forEach(s => {
        schedules.push(s);
      })
    });
    const book = XLSX.utils.book_new();
    const nurses = XLSX.utils.json_to_sheet(
      schedules.map((item, index) => {
        return {
          '번호' : index+1,
          '상태' : item.lecture_status_type==='2'?'미배정':item.lecture_status_type==='1'?'완료':'확정',
          '날짜': item.start_date,
          '시간': item.start_time+'~'+item.end_time,
          '기업명': (item.project_type==='b2c')?'HSG 공개과정':item.company_name,
          '프로젝트명': item.project_title,
          '운영자': item.operator,
          '주제': item.lecture_subject,
          '강사명': item.lecturer_name.split(',').map(item=>{return item.split('_')[1]}).join(','),
          '강의장소': item.lecture_place,
          'PM': item.pm,
          'CM': item.cm,
        }
      }), 
      { 
        header : [
          '번호',
          '상태',
          '날짜',
          '시간',
          '기업명',
          '프로젝트명',
          '운영자',
          '주제',
          '강사명',
          '강의장소',
          'PM',
          'CM',
        ], 
        skipHeader : false 
      } 
    );

    nurses["!cols"] = [
      { wpx : 60 } 
    , { wpx : 80 }  
    , { wpx : 100 } 
    , { wpx : 120 }  
    , { wpx : 120 }  
    , { wpx : 150 } 
    , { wpx : 80 } 
    , { wpx : 120 } 
    , { wpx : 80 } 
    , { wpx : 150 } 
    , { wpx : 80 } 
    , { wpx : 80 } 
    ]

    XLSX.utils.book_append_sheet( book, nurses, "NURSES" );
    XLSX.writeFile( book, moment(searchDate).format('YYYY년MM월_')+"운영일정.xlsx" ); 
    setIsLoading(false);   
  }

  /* ======================================================
   * hooks
   * ====================================================== */
  useEffect(() => {
    if (searchParams && searchParams.searchDateStart) {
      setSearchDate(String(searchParams.searchDateStart)); 
    } else {
      setSearchDate(moment().format('YYYY-MM-DD'));
    }
  }, [searchParams]);  

  useEffect(() => {
    if (scheduleList) {
      setScheduleData(scheduleList); 
    } else {
      setScheduleData([]); 
    }
  }, [scheduleList]);  
  
  return (
    <CardLayout title={(
      <Breadcrumb>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>운영</Breadcrumb.Item>
    </Breadcrumb>      
    )}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <SearchBox />
          <Spin spinning={isLoding} tip="처리중입니다. 잠시만 기다려 주세요." size="large">
            <Calender 
              current={searchDate} 
              schedules={scheduleData} 
              type={'op'}
              onPrevMonth={prevMonth} 
              onNextMonth={nextMonth} 
              onClickItem={onClickInfo}
              makePopupContent={makePopupContent}
              onExcelDownload={onExcelDownload}
            />
          </Spin>
        </Space>              
    </CardLayout>
  )
};

export default Operate;    